// If the value is an array, just return it, otherwise make a single entry array out of it and return it.
export const coerceArray = <T>(value: T | T[]) => (Array.isArray(value) ? value : [value]);

// By default TS will infer `string[]` for an array so use this function to
// extract string literal unions. This will automatically type your array.
// Example:
// const dimensions1 = ["height", "width"]; // dimensions1 type is string[].
// const dimensions = stringLiteralArray(["height", "width"]);
// dimensions type is ("height"|"width")[] (an array that can only have "height" and "width" in it)
export const stringLiteralArray = <LiteralString extends string>(xs: LiteralString[]) => xs;
